import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';
import Divider from '../../../Divider';

import { TransactionCardSkeletonProps } from './TransactionCardSkeleton.types';

const TransactionCardSkeleton: React.FC<TransactionCardSkeletonProps> = ({ className }) => {
  return (
    <Card className={`relative flex flex-column p4 ${className}`}>
      <div className="flex flex-column">
        <div className="flex flex-justify">
          <BaseSkeleton width={120} height={40} />
          <Skeleton variant="rect" width={82} height={36} />
        </div>
        <div className="flex flex-justify mt4 mb2">
          <BaseSkeleton width={120} />
          <BaseSkeleton width={120} />
        </div>
      </div>
      <Divider className="mt2" />
      <div className="flex flex-justify mt4">
        <div className="flex flex-column">
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} />
        </div>
        <div className="flex flex-column">
          <BaseSkeleton width={50} className="mb2 mt4" />
          <BaseSkeleton width={50} className="mb2" />
          <BaseSkeleton width={50} className="mb2" />
          <BaseSkeleton width={50} />
        </div>
      </div>
      <Divider className="mt2" />
      <div className="flex flex-justify mt4">
        <div className="flex flex-column">
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} />
        </div>
        <div className="flex flex-column">
          <BaseSkeleton width={50} className="mb2 mt4" />
          <BaseSkeleton width={50} />
        </div>
      </div>
    </Card>
  );
};

export default TransactionCardSkeleton;
export { TransactionCardSkeletonProps };
